import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Category } from '../../../../documents';
import { Observable } from 'rxjs';
import { MdlDialogReference } from '@angular-mdl/core';
import { FormControl, Validators } from '@angular/forms';
import { UploadedDocumentsStorage } from '../../storages/uploaded-documents-storage';
import { FileToLanguage } from '../../../../covance-file-upload/covance-file-upload.component';
import { FileFormArray } from '../../../../covance-file-upload/file-form-array';
import { UPLOAD_DLG_DATA_TOKEN, UploadDialogData } from '../base/upload-dialog-data';
import { Settings } from '../../../../core';
import { UploadConfirmationDialog } from '../base/upload-confirmation-dialog';
import { GeneralUploadDialogBase } from './general-upload-dialog-base';
import { MethodUploadOptions } from '../base/method-upload-options';
import { GeneralUnreadReportsStorage } from '../../../../general-documents/general-unread-reports-storage';

@Component({
    selector: 'general-training-materials-upload',
    template: require('./general-training-materials-upload.component.html'),
    styles: [require('./general-training-materials-upload.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralTrainingMaterialsUploadComponent extends GeneralUploadDialogBase {
    public readonly subcategoryCtrl: FormControl;
    public readonly titleCtrl: FormControl;
    public readonly fileFormArray: FileFormArray;
    public readonly allowedFileExtensions: string[];
    public readonly subcategories$: Observable<Category[]>;
    public selectedFiles: FileToLanguage;

    constructor(
        dialog: MdlDialogReference,
        uploadConfirmationDialog: UploadConfirmationDialog,
        private readonly uploadedDocumentsStorage: UploadedDocumentsStorage,
        @Inject(UPLOAD_DLG_DATA_TOKEN) readonly dialogData: UploadDialogData<void>,
        readonly settings: Settings,
        unreadStorage: GeneralUnreadReportsStorage
    ) {
        super(uploadedDocumentsStorage, dialog, uploadConfirmationDialog, unreadStorage);

        this.subcategoryCtrl = new FormControl(null, [Validators.required]);
        this.titleCtrl = new FormControl(null, [Validators.required]);
        this.fileFormArray = new FileFormArray();
        this.editorForm.addControl('subcategory', this.subcategoryCtrl);
        this.editorForm.addControl('title', this.titleCtrl);
        this.editorForm.addControl('files', this.fileFormArray);

        this.allowedFileExtensions = settings.uploadedFileExtensionsByCategoryId(dialogData.category.categoryId);
        this.subcategories$ = dialogData.subCategories$;
    }

    public onFilesChanged(selectedFiles: FileToLanguage) {
        this.selectedFiles = selectedFiles;
    }

    public async addFiles() {
        const confirmed = await this.showConfirm();

        if (confirmed) {
            this.upload(new MethodUploadOptions(
                this.subcategoryCtrl.value,
                this.selectedFiles,
                { 
                    title: this.titleCtrl.value
                },
                () => this.uploadedDocumentsStorage.forceLoadDocuments()
            ));
        }
    }
}